import myFetchWithId, { exportWithId } from '../helpers/myFetch';
import { qguidanceTransfer as transfer } from '../helpers/qguidanceTransfer';
import { requestFetchApi , receiveFetchApi } from './search.actions';
import { conceptmap } from "../constants";


export function localFetchConceptmapData(keyword, widgetId, isDashboard, posttype, sentiment) {
  let params = {
    text: keyword,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
  };
  
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return myFetchWithId(widgetId, false, true)(`${process.env.REACT_APP_API}/q/qguidance`, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveConceptmapData(json))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}

function receiveConceptmapData(json){
  return {
    type: conceptmap.RECEIVE_CONCEPTMAP,
    conceptmap: transfer(json),
    receivedAt: Date.now(),
  } 
}

export function localFetchHotConceptmapData(keynum,keyword, widgetId, isDashboard, posttype, sentiment) {
  let params = {
    keynum:keynum,
    text: keyword,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
  };
  
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }

  return myFetchWithId(widgetId, false, true)(`${process.env.REACT_APP_API}/q/qtextrank`, params)
    .then(json => receiveLocalConceptmapData(json))
}
function receiveLocalConceptmapData(json) {
  const ans = transfer(json);
  return {
    conceptmap: transfer(json),
    receivedAt: Date.now()
  }
}

export function localFetchTopicTrendConceptmapData(keyword, widgetId, isDashboard, posttype, sentiment) {
  let params = {
    text: keyword,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
  };
  
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }

  return myFetchWithId(widgetId, false, true)(`${process.env.REACT_APP_API}/q/qguidance_title`, params)
    .then(json => receiveTopicTrendConceptmapData(json))
}
function receiveTopicTrendConceptmapData(json) {
  const ans = transfer(json);
  return {
    conceptmap: transfer(json),
    receivedAt: Date.now()
  }
}

export function localFetchSocialTagConceptmapData(keyword, widgetId, isDashboard, posttype, sentiment) {
  let params = {
    text: keyword,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
  };
  
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }

  return myFetchWithId(widgetId, false, true)(`${process.env.REACT_APP_API}/q/social_tag`, params)
    .then(json => receiveSocialTagConceptmapData(json))
}
function receiveSocialTagConceptmapData(json) {
  const ans = transfer(json);
  return {
    conceptmap: transfer(json),
    receivedAt: Date.now()
  }
}




export function exportConceptmap(keyword, widgetId, isDashboard, posttype, sentiment, value,keynum) {
  let params = {
    keynum: keynum,
    text: keyword,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
  };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }
  if (value === 'guidance'){
    return exportWithId(widgetId)(`${process.env.REACT_APP_API}/q/qguidance_export`, params);
  }else if( value ==='textrank'){
    return exportWithId(widgetId)(`${process.env.REACT_APP_API}/q/qtextrank_export`, params);
  }else{
    return exportWithId(widgetId)(`${process.env.REACT_APP_API}/q/qguidance_export_title`, params);
  }
  
}


// topology init request
export function fetchTopologyInit(keyword, widgetId, isDashboard, posttype, sentiment, abb) {
  let params = {
    text: keyword,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
  };
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return myFetchWithId(widgetId, false, true)(`${process.env.REACT_APP_API}/q/qguidance`, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveTopologyInit(json, keyword, abb))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}

function receiveTopologyInit(json, keyword, abb) {
  const searchKeyword = abb ? abb: keyword;
  // first create a node with keyword
  const keywordNode = {
    group: 999,
    id: 0,
    label: searchKeyword,
    uid: 'keyword_from_search',
    cid: 0,
    fetched: true
  };
  if(transfer(json).length > 0) {
    const conceptNode = transfer(json).map((node, index) => {
      return({
        group: Math.abs(node.cluster) < 24 ? Math.abs(node.cluster) : 24,
        id: index + 1,
        label: node.str,
        title: `<div class="topology-node-title"><h3>${node.str}</h3></div>`,
        uid: node.str,
        cid: 0,
        fetched: false,
        searchKeyword: `${node.str}AND${searchKeyword}`
      });
    })
    conceptNode.unshift(keywordNode);
    const edgesData = transfer(json).map((node, index) => {
      return ({
        from: 0,
        to: index + 1
      })
    });

    return {
      type:conceptmap.RECEIVE_TOPOLOGY,
      nodesData: conceptNode,
      edgesData: edgesData,
      receivedAt: Date.now()
    }
  }
  return {
    type:conceptmap.RECEIVE_TOPOLOGY,
    nodesData: [],
    edgesData: [],
    receivedAt: Date.now()
  };
}


// topology more
export function fetchTopologyMore(selectNodeInfo) {
  let params = {
    text: selectNodeInfo[0],
  };
  return myFetchWithId('', false, true)(`${process.env.REACT_APP_API}/q/qguidance`, params)
    .then((json, nodeId, searchKeyword, count) => receiveTopologyMore(json, selectNodeInfo[3], selectNodeInfo[0], selectNodeInfo[4]))
}

function receiveTopologyMore(json, clickId, searchKeyword, count) {
  if(transfer(json).length >0) {
    const conceptNode = transfer(json).map((node, index) => {
      return({
        group: Math.abs(node.cluster) < 24 ? Math.abs(node.cluster) : 24,
        id: index + 100*count,
        label: node.str,
        title: `<div class="topology-node-title"><h3>${node.str}</h3></div>`,
        uid: node.str,
        fetched: false,
        searchKeyword: `${node.str}AND${searchKeyword}`
      });
    })
    const edgesData = transfer(json).map((node, index) => {
      return ({
        from: clickId,
        to: index + 100*count
      })
    });

    console.log({conceptNode, edgesData, count});

    return {
      nodesDataMore: conceptNode,
      edgesDataMore: edgesData,
      receivedAt: Date.now()
    }
  } else {
    return {
      nodesDataMore: [],
      edgesDataMore: [],
      receivedAt: Date.now()
    };
  }
}



// WEBPACK FOOTER //
// ./src/actions/widgetConceptmap.actions.js